import { useRouter } from "src/helpers"; // import lodash from 'lodash';
// import deepdash from 'deepdash-es';

import { withHookForSet, withUpdateSet } from "src/modules/set/operations";
import { compose } from "src/helpers";

import EditView from "./component";

const Edit = (props) => {
    const { updateSet } = props;
    const router = useRouter();

    const onFinish = async (values: any) => {
        await updateSet(values);
        router.push("/set");
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return (
        <EditView
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            {...props}
        />
    );
};

export default compose(withHookForSet, withUpdateSet)(Edit);
